import {DEFAULT_MONTHLY_PRICE_CENTIMES, DEFAULT_YEARLY_PRICE_CENTIMES} from "@mytour/shared";
import {Splitter} from "@mytour/ui/layout";
import {Button} from "reactstrap";
import {CustomCard} from "./CustomCard";

type Props = {
  monthlyCentimes: number;
  yearlyCentimes: number;
  onRegister: (type: "monthly" | "yearly") => void;
};

export function CustomPrice({monthlyCentimes, yearlyCentimes, onRegister}: Props) {
  if (monthlyCentimes === 0 && yearlyCentimes === 0) {
    return (
      <div style={{width: "100%", height: "100%"}}>
        <Button
          style={{width: "100%", height: "100%"}}
          onClick={handleMonthlyClick}
          color="primary"
        >
          <CustomCard
            cycle="monthly"
            amountCentimes={monthlyCentimes}
            defaultCentimes={DEFAULT_MONTHLY_PRICE_CENTIMES}
          />
        </Button>
      </div>
    );
  }
  return (
    <Splitter>
      <div style={{width: "100%", height: "100%"}}>
        <Button
          style={{width: "100%", height: "100%"}}
          onClick={handleMonthlyClick}
          color="primary"
        >
          <CustomCard
            cycle="monthly"
            amountCentimes={monthlyCentimes}
            defaultCentimes={DEFAULT_MONTHLY_PRICE_CENTIMES}
          />
        </Button>
      </div>
      <div style={{width: "100%", height: "100%"}}>
        <Button
          style={{width: "100%", height: "100%"}}
          onClick={handleYearlyClick}
          color="primary"
        >
          <CustomCard
            cycle="yearly"
            amountCentimes={yearlyCentimes}
            defaultCentimes={DEFAULT_YEARLY_PRICE_CENTIMES}
          />
        </Button>
      </div>
    </Splitter>
  );

  function handleMonthlyClick() {
    onRegister("monthly");
  }

  function handleYearlyClick() {
    onRegister("yearly");
  }
}
